import { render, staticRenderFns } from "./NumericType.vue?vue&type=template&id=2e04d894&scoped=true&"
import script from "./NumericType.vue?vue&type=script&lang=js&"
export * from "./NumericType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04d894",
  null
  
)

export default component.exports